import Cookie from 'js-cookie';

import isApp from './ua';
const unAuthPagePaths = [
  '/app/user/retrieve',
  '/app/user/recomment-buy-coin',
  '/app/user/bundle-purchase',
  '/app/user/sub-account-login',
  '/app/user/sub-account-login/',
  '/sign-up',
  '/app/user/trading-tool',
  '/app/user/reserve-ratio',
  '/app/user/proof-of-reserve',
  '/app/eddform',
  '/tg-oauth',
  '/app/user/audit-report',
];

const adapterAppRoutes = [
  '/app/user/auto-ban-account',
  '/app/user/auto-ban-account/',
  '/notifications',
  '/app/user/offline-verify',
  '/app/user/offline-verify/',
];
/*
  特殊判断条件在这里加, 
  example: /app/user/auto-ban-account 路由携带参数为未登录状态下可访问, 未携带参数未登录状态下不可访问                      
*/
export const unAuthCondition: { [key: string]: boolean } = {
  autoBan:
    location.pathname !== '/app/user/auto-ban-account' &&
    location.pathname.includes('/app/user/auto-ban-account'),
  securityFind:
    Cookie.get('self-unbind-token') !== '' &&
    (location.pathname == '/app/user/security-item-find' ||
      location.pathname == '/app/user/security-item-find/'),
  userFeedback: /^\/[a-z]{2,3}(-[A-Z]{2,3})?\/user-feedback[/]?$/.test(
    location.pathname,
  ),
  unsubscribe: /^\/[a-z]{2,3}(-[A-Z]{2,3})?\/unsubscribe[/]?$/.test(
    location.pathname,
  ),
  offlineVerify: location.pathname.includes('/app/user/offline-verify'),
};

export const isUnAuthPage = () => {
  const { pathname } = location;
  let isUnAuthPage = false;
  if (unAuthPagePaths.includes(pathname)) {
    isUnAuthPage = true;
  } else {
    Object.keys(unAuthCondition).forEach((item) => {
      if (unAuthCondition[item]) isUnAuthPage = true;
    });
  }

  if (isApp()) {
    if (adapterAppRoutes.some((path) => location.pathname.indexOf(path) > -1)) {
      isUnAuthPage = true;
    }
  }
  return isUnAuthPage;
};
